import ReadonlyRating from '@modules/common/components/readonly-rating';
import { H4 } from '@modules/common/components/typography/H4';
import { YelpLogo } from '@modules/common/components/yelp-logo/yelp-logo';
import { Coordinates, Location } from 'types/business';
import { CHOOSE_YOUR_OWN, LET_THEM_CHOOSE, SearchService } from '@lib/constants/variants';
import { GiftCardTypes } from './giftcard-type';
import { GoogleRating } from '@modules/common/components/google-rating';
import { GoogleLogo } from '@modules/common/components/google-logo';
import { useSearchService } from '@lib/context/search-service-context';
import { H1 } from '@modules/common/components/typography/H1';
import GoogleMapsLink from '@modules/business/components/google-maps-link';

type Props = {
  id?: string;
  rating: number;
  review_count: number;
  name: string;
  location: Location;
  phone: string;
  coordinates: Coordinates;
  distance: number;
  url: string;
  search_provider: string;
  description?: string;
};

const MediumGiftCardInformation = ({ ...props }: Props) => {
  const { rating, review_count, name, location, phone, url, id, search_provider, description, coordinates } = props;
  const searchService = useSearchService();

  return (
    <div>
      {name === LET_THEM_CHOOSE ? (
        <H1 className="text-[32px] md:!text-5xl mt-1 uppercase mb-4">{CHOOSE_YOUR_OWN}</H1>
      ) : (
        <H1 className={`text-[32px] !text-5xl hidden md:block mt-1 ${!id ? 'uppercase mb-4' : ''}`}>{name}</H1>
      )}
      {name === LET_THEM_CHOOSE ? <GiftCardTypes /> : ''}

      {!searchService?.loading && (
        <div className="mt-1 space-x-1.5 items-center hidden md:flex">
          {id && (
            <>
              <a href={url} target="blank" aria-label="go to business">
                {search_provider === SearchService.YELP ? (
                  <ReadonlyRating count={rating} size="1rem" />
                ) : (
                  <GoogleRating count={rating} size="1rem" />
                )}
              </a>
              <div className="flex items-center">
                <div className="flex mt-1 items-center space-x-1">
                  <H4 className="text-sm">
                    <a href={url} target="blank">
                      {rating}
                    </a>
                  </H4>
                  <a href={url} target="blank">
                    <span className="flex text-sm text-black items-center">
                      ({review_count})
                      <span className="flex items-center ml-0.5 font-bold">
                        on{' '}
                        <span className="ml-1 -mt-1">
                          {search_provider === SearchService.YELP ? <YelpLogo /> : <GoogleLogo />}
                        </span>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {id && (
        <div className="hidden md:block">
          <div className="product-description-address flex-col my-3">
            <div className="product-description-addressItem product-description-addressItem-maplink">
              <img src="/map-icon.svg" alt="Location Icon" className="inline mr-2" />
              <GoogleMapsLink id={id} search_provider={search_provider} coordinates={coordinates} mapUrl={url} address={location?.display_address?.join(', ')} />
            </div>
            {phone && (
              <div className="product-description-addressItem hidden md:flex">
                <img src="/phone-icon.svg" alt="Location Icon" className="inline mr-2" />
                <div className='product-phoneNumbers'>
                  <a href={`tel:${phone}`}>
                    {phone}
                  </a>
                </div>
              </div>
            )}
          </div>
          {description && (
            <div className="product-description my-5">
              <div className="product-description-content">
                <div className="product-description-line"></div>
                <div>
                  <p>{description}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MediumGiftCardInformation;
